import { apiDomain as api, apiKey } from '../appConfig';

const workNo = async (data) =>
	fetch(`${api}/SCWS/Service.asmx/CASWORKNO`, {
		method: 'POST',
		body: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Ocp-Apim-Subscription-Key': apiKey,
		},
	})
		.then((res) => res.json())
		.catch((err) => console.error(err));

export default workNo;



// WEBPACK FOOTER //
// ./src/js/fetch/workNo.js